import { alertTrade } from '@moal/api'
import PropTypes from 'prop-types'
import { toastSuccess } from '../../../utils/toast'
import Modal from '../../Utilities/Modal'
import Trade from '../Trade'

const ResendModal = ({ open, setOpen, message }) => {
  const handleResend = async () => {
    const response = await alertTrade({ id: message._id })
    if (response && response.status === 201) {
      toastSuccess('Trade notification resent.')
    }
    toastSuccess('Trade notification resent.')
    setOpen(false)
  }

  return (
    <Modal
      title="Resend Trade Notification"
      open={open}
      setOpen={setOpen}
      confirmFunction={handleResend}
    >
      <Trade message={message} />
    </Modal>
  )
}

ResendModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  message: PropTypes.object.isRequired
}

export default ResendModal
